import tasksActions from './tasks.actions';
import groupTasksActions from './group.tasks.actions';

export default {
  ...tasksActions,
  ...groupTasksActions
};
